/**
 * Staging record for inbound NF-e XML (modelo 55).
 * Logical path: org/{orgId}/invoice-import
 *
 * XML bytes live in Storage at org/{orgId}/invoice-imports/{id}.xml
 * (not in the Firestore doc — 1 MiB ceiling).
 *
 * Transactional: Auditable only — no Inactivatable. Lifecycle is `status`.
 * Promotion to Invoice fills `invoiceId` and sets status `promoted` (separate request).
 */
export const INVOICE_IMPORT = 'InvoiceImport';
export const InvoiceImportStatusValues = [
    'received',
    'parsed',
    'invalid',
    'promoted',
    'discarded',
];
export const InvoiceImportSourceKindValues = [
    'manual',
    'agent',
];
//# sourceMappingURL=invoice-import.js.map